import * as React from "react";
import { ContextStore } from "../../../../../../../../react-core/Flux/Variables";
import { CommonHelper } from "../../../../../../../../react-core/Helpers/CommonHelper";
import { Lightbox, LightboxType } from "../../../../../../../../react-core/Html/Components/Lightbox";
import { FormComponent } from "../../../../../../../../react-core/Html/FormComponent";
import { PartLoading } from "../../../../../../../../react-core/Html/PartLoading";
import { SelectEditor } from "../../../../../../../../react-core/Html/SelectEditor";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { DisinvestmentStrategyType } from "../../../../../../../../Wrap/Constants/Enums/Client/DisinvestmentStrategyType";
import { ContextType } from "../../../../../../../../Wrap/Constants/Enums/ContextType";
import { CurrencyCode } from "../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { ChargeType } from "../../../../../../../../Wrap/Constants/Enums/ProductOverview/Charges/ChargeType";
import { ServiceProposition } from "../../../../../../../../Wrap/Constants/Enums/ServiceProposition";
import { UserClaim } from "../../../../../../../../Wrap/Constants/Enums/UserClaim";
import { ServiceValidationError } from "../../../../../../../../Wrap/Core/DataTypes/ServiceValidation/ServiceValidationError";
import { AccountDisinvestmentStrategy } from "../../../../../../../../Wrap/Models/Domains/Account/AccountDisinvestmentStrategy";
import { ClientAccount } from "../../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { PortfolioManagerFee } from "../../../../../../../../Wrap/Models/Domains/ProductOverview/Charges/PortfolioManagerFee";
import { ProductCharge } from "../../../../../../../../Wrap/Models/Domains/ProductOverview/Charges/ProductCharge";
import { Permission } from "../../../../../../../Shared/Permission/Permission";
import { checkPermission } from "../../../../../../../Shared/Permission/PermissionHelper";
import AriaTooltip from "../../../../../../../Shared/Tooltip/AriaTooltip";
import { Navigator } from "../../../../../../../Shared/Wizards/Entities/Navigator";
import { Methods } from "../../../../../../Common/CommonHelper";
import { Urls } from "../../../../../../Urls";
import { DisinvestmentStrategyTypeArray } from "../../../../NewBusinessWizard/Resource/Contents";
import { PortfolioDashboardStore } from "../../../Store/Variable";
import { TransactionEnum } from "../../Transactions/Resource/Contents";
import { ProductOverviewChargeAction } from "../Action/ProductOverviewChargeAction";
import { DisinvestmentStrategyTypeMap, DisinvestmentTipMsg } from "../Constant/Content";
import { ProductOverviewChargeStore } from "../Stores/Variable";
import { DrawdownPriceLock } from "./DrawdownPriceLock";
import { PensionArrangement } from "../../../../../../../../Wrap/Models/Models/Account/PensionArrangement";
import { UserStore } from "../../../../../../Stroes/Variable";
import { DrawdownPriceLockModel } from "../../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/DrawdownPriceLockModel";
import { ProductDetails } from "../../../../../../../../Wrap/Models/Domains/Account/ProductDetails";
import { ProductDetailsStore } from "../../../../Common/Account/ProductDetails/Store/Variable";
import { HierarchyIdHelper } from "../../../../../../../Shared/Common/HierarchyIdHelper";

export interface ChargesTableProps {
    subAccountHierarchyId?: string;
    selectedProduct?: SubAccountType;
    subClAccountId?: string;
    accountHierarchyId?: string;
}

interface IChargesTableState {
    data: ProductCharge;
    isLoading: boolean;
    isDrawdownPriceLockLoading: boolean;
    showAccountDisinvestmentStrategy: boolean;
    accountDisinvestmentStrategy: DisinvestmentStrategyType;
    tempDisinvestmentStrategy: DisinvestmentStrategyType;
    clientAccount: ClientAccount;
    pensionArrangements: PensionArrangement[];
    drawdownPriceLock: DrawdownPriceLockModel;
    productDetails: ProductDetails;
}

export class ChargesTable extends FormComponent<ChargesTableProps, IChargesTableState> {
    isAdmin: boolean;
    constructor(props: any) {
        super(props);
        this.state = {
            data: null,
            isLoading: true,
            isDrawdownPriceLockLoading: false,
            showAccountDisinvestmentStrategy: false,
            accountDisinvestmentStrategy: DisinvestmentStrategyType.NotSpecified,
            tempDisinvestmentStrategy: DisinvestmentStrategyType.NotSpecified,
            pensionArrangements: [],
            drawdownPriceLock: {},
            clientAccount: PortfolioDashboardStore.getData()?.find(
                (ele) => ele.HierarchyId == props.accountHierarchyId
            ),
            productDetails: null,
        };
        this.isAdmin = UserStore.getUserInfo()?.IsAdmin != null ? UserStore.getUserInfo().IsAdmin : true;
        this.subscribeToStore(ProductOverviewChargeStore, () => this.onNChargeStoreChange());
        this.subscribeToStore(ProductDetailsStore, () => this.onProductDetailsStoreChange());
    }

    private onNChargeStoreChange() {
        const data = ProductOverviewChargeStore.getData();
        const isLoading = ProductDetailsStore.isLoading();
        this.setState({
            data: data,
            isLoading: isLoading,
        });
    }

    private onProductDetailsStoreChange() {
        const data = ProductDetailsStore.getData();
        const isLoading = ProductOverviewChargeStore.isLoading();
        this.setState({
            productDetails: data,
            isLoading: isLoading,
        });
    }

    public componentDidMount() {
        this.getData();
        this.getAccountDisinvestmentStrategy();
        this.getPensionArrangement();
        this.getDrawdownPriceLock();
    }

    public componentDidUpdate(prevProps: ChargesTableProps): void {
        if (prevProps.selectedProduct != this.props.selectedProduct) {
            this.getData();
        }
    }
    private getData() {
        const { subAccountHierarchyId } = this.props;
        this.setState({ isLoading: true });
        ProductOverviewChargeAction.getCharge(subAccountHierarchyId);
        ProductOverviewChargeAction.getProductDetails(subAccountHierarchyId);
    }

    private getPensionArrangement() {
        const { selectedProduct, subAccountHierarchyId } = this.props;
        if (selectedProduct == SubAccountType.Npr || selectedProduct == SubAccountType.JuniorSipp) {
            ProductOverviewChargeAction.getPensionArrangement(
                subAccountHierarchyId,
                (res: PensionArrangement[]) => {
                    this.setState({ pensionArrangements: res });
                });
        }
    }

    private getDrawdownPriceLock() {
        const { selectedProduct, subAccountHierarchyId } = this.props;
        if (selectedProduct == SubAccountType.Npr || selectedProduct == SubAccountType.JuniorSipp) {
            this.setState({ isDrawdownPriceLockLoading: true });
            ProductOverviewChargeAction.getDrawdownPriceLock(
                subAccountHierarchyId,
                (res: DrawdownPriceLockModel) => {
                    this.setState({ drawdownPriceLock: res, isDrawdownPriceLockLoading: false });
                });
        }
    }

    private getAccountDisinvestmentStrategy() {
        const { accountHierarchyId } = this.props;
        ProductOverviewChargeAction.getAccountDisinvestmentStrategy(
            accountHierarchyId,
            (res: AccountDisinvestmentStrategy) => {
                this.setState({ accountDisinvestmentStrategy: res.DisinvestmentStrategyType });
            }
        );
    }

    private getChargePercentageFormat(val?: number): string {
        const value = val ? val.toFixed(2) : 0;
        return value + "%";
    }

    private renderPortfolioManagerFeeDom(PortfolioManagerFees: Array<PortfolioManagerFee>): JSX.Element[] {
        if (PortfolioManagerFees && PortfolioManagerFees.length > 0) {
            const products: JSX.Element[] = [];
            PortfolioManagerFees.forEach((item, index) => {
                const product: JSX.Element = (
                    <tr key={index}>
                        <td className="cell-left">{item.PortfolioName}</td>
                        <td className="cell-right">
                            {this.getChargePercentageFormat(item.Percentage)} {" " + item.Frequency}
                        </td>
                    </tr>
                );
                products.push(product);
            });
            return products;
        } else {
            return null;
        }
    }

    private renderAccountDisinvestmentStrategyView() {
        return (
            <Lightbox
                show={this.state.showAccountDisinvestmentStrategy}
                title={"Auto-disinvestment strategy"}
                contentAfterTitle={null}
                onClose={() => {
                    this.setState({ showAccountDisinvestmentStrategy: false });
                }}
                type={LightboxType.Modal}
                cssWrapper="is-default-lightbox"
            >
                <div className="row">
                    <div className="col-12 col-sm-fluid col-max-245">
                        <SelectEditor
                            key="DisinvestmentStrategyTypeOptions"
                            selected={this.state.accountDisinvestmentStrategy}
                            options={DisinvestmentStrategyTypeArray}
                            getText={(x) => DisinvestmentStrategyTypeMap[x]}
                            onChange={(val) => {
                                this.setState({ tempDisinvestmentStrategy: val });
                            }}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-auto">
                        <button
                            className="button"
                            onClick={(val) => this.setState({ showAccountDisinvestmentStrategy: false })}
                        >
                            Cancel
                        </button>
                    </div>
                    <div className="col-auto">
                        <button className="btn primary" onClick={(val) => this.saveAccountDisinvestmentStrategy()}>
                            Save
                        </button>
                    </div>
                </div>
            </Lightbox>
        );
    }

    private saveAccountDisinvestmentStrategy() {
        ProductOverviewChargeAction.updateAccountDisinvestmentStrategy(
            {
                HierarchyId: this.props.accountHierarchyId,
                DisinvestmentStrategyType: this.state.tempDisinvestmentStrategy,
            },
            (callBack: Array<ServiceValidationError>) => {
                this.setState({
                    showAccountDisinvestmentStrategy: false,
                    accountDisinvestmentStrategy: this.state.tempDisinvestmentStrategy,
                });
            }
        );
    }

    private isLegacyProduct(selectedProduct: SubAccountType): boolean {
        return (
            selectedProduct == SubAccountType.OffshoreBond ||
            selectedProduct == SubAccountType.OnshoreBond ||
            selectedProduct == SubAccountType.Sipp
        );
    }

    public render(): JSX.Element {
        const { data, isLoading, isDrawdownPriceLockLoading, clientAccount, drawdownPriceLock, productDetails } = this.state;
        const { selectedProduct, subClAccountId, subAccountHierarchyId } = this.props;
        if (isLoading || isDrawdownPriceLockLoading) { return <PartLoading isLoading={true} />; }

        return (
            <>
                <div className="ad d1">
                    <h1 className="h2 mb-22">Charges</h1>
                    <div className="row">
                        <div className="col-12 col-sm-6">
                            <h2 className="h3 mb-5">Charges details</h2>
                            <div className="panel-subtle pt-0">
                                <table className="table-subtle table-first-last-cell-padding-reset has-first-cell-highlighted mb-0 row-higher">
                                    <tbody>
                                        <tr>
                                            <th scope="row">
                                                Platform charge
                                                <AriaTooltip cssWrapper="is-info-icon ml-5" showCloseButton={true}>
                                                    {
                                                        "This value is based on the most recent Platform Charge event. The next Platform charge amount may be vary from this value."
                                                    }
                                                </AriaTooltip>
                                            </th>
                                            <td className="cell-right">
                                                {this.getChargePercentageFormat(data?.PlatformChargePercentage)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th scope="row">
                                                Ongoing adviser charge
                                                {checkPermission(UserClaim.AdviserPortalDluAdviserChargingCanView) && (
                                                    <a
                                                        type="button"
                                                        title="Edit"
                                                        className="edit-circle-icon-button ml-5 label-sr-only"
                                                        href={
                                                            "/clients/fees/AdviserCharging/AdviserCharging.aspx?claccountid=" +
                                                            subClAccountId
                                                        }
                                                    >
                                                        <span className="icon"></span>
                                                        <span className="sr-only">Edit ongoing adviser charge</span>
                                                    </a>
                                                )}
                                            </th>
                                            <td className="cell-right">
                                                {data?.OngoingAdviserCharge != null
                                                    ? (data?.OngoingAdviserCharge?.ChargeType == ChargeType.Percentage
                                                        ? this.getChargePercentageFormat(
                                                            data?.OngoingAdviserCharge?.Value
                                                        )
                                                        : Methods.getMoneyFormat(
                                                            {
                                                                Amount: data?.OngoingAdviserCharge?.Value,
                                                                Currency: CurrencyCode.GBP,
                                                            },
                                                            true
                                                        )) +
                                                    (" " + data?.OngoingAdviserCharge?.Frequency)
                                                    : "N/A"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th scope="row">OAC next payment date</th>
                                            <td className="cell-right">
                                                {data?.OngoingAdviserCharge != null
                                                    ? JsonDateParser.getFormatDate(
                                                        data?.OngoingAdviserCharge?.NextPaymentDate,
                                                        "dd/MM/yyyy"
                                                    )
                                                    : "N/A"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Off Platform Investment Charge next payment date</th>
                                            <td className="cell-right">
                                                {data?.NextOuterRingInvestmentChargeDate != null
                                                    ? JsonDateParser.getFormatDate(
                                                        data?.NextOuterRingInvestmentChargeDate,
                                                        "dd/MM/yyyy"
                                                    )
                                                    : "N/A"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Family linking</th>
                                            <td className="cell-right">
                                                {productDetails.FamilyId != null ? "Yes" : "No"}
                                            </td>
                                        </tr>
                                        {data?.ProductAdministrationChargePercentage != null &&
                                            this.isLegacyProduct(selectedProduct) && (
                                                <tr>
                                                    <th scope="row">Product administration charge</th>
                                                    <td className="cell-right">
                                                        {this.getChargePercentageFormat(
                                                            data?.ProductAdministrationChargePercentage
                                                        )}
                                                    </td>
                                                </tr>
                                            )}
                                    </tbody>
                                </table>
                                {(selectedProduct == SubAccountType.Npr || selectedProduct == SubAccountType.JuniorSipp) && (
                                    <Permission userClaim={UserClaim.AdviserPortalPerformanceChargesCanView}>
                                        <div>
                                            <a href={
                                                "/clients/fees/fees-Clientschedules.aspx?claccountid=" +
                                                clientAccount?.HeadClAccountId
                                            }>
                                                <button className="hyperlink">
                                                    View terms
                                                </button>
                                            </a>
                                        </div>
                                    </Permission>
                                )}
                                <Permission userClaim={UserClaim.AdviserPortalPerformanceChargesCanView}>
                                    <div>
                                        <button
                                            className="hyperlink"
                                            onClick={() =>
                                                Navigator.navigateTo(
                                                    Urls.get().main.PortfolioDashboard({
                                                        hierarchyId: ContextStore.getUrlParamsHierarchyId(
                                                            ContextType.Customer
                                                        ),
                                                    }).transactions,
                                                    {
                                                        scrollAfterNavigating: true,
                                                        queryParamsObject: {
                                                            transtypeselect: TransactionEnum.charges,
                                                            hierarchyid: this.props.subAccountHierarchyId,
                                                        },
                                                    }
                                                )
                                            }
                                        >
                                            View charges
                                        </button>
                                    </div>
                                </Permission>
                            </div>
                        </div>
                        <div className="col-12 col-sm-6">
                            {data?.PortfolioManagerFees.length > 0 && (
                                <>
                                    <h1 className="h2 mb-22">Portfolio manager fee</h1>
                                    <div className="panel-subtle row-higher">
                                        <table className="table-subtle table-first-last-cell-padding-reset has-first-cell-highlighted mb-0">
                                            <thead>
                                                <tr>
                                                    <th className="cell-left">Portfolio name</th>
                                                    <th className="cell-right">Portfolio fee</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.renderPortfolioManagerFeeDom(data?.PortfolioManagerFees)}
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            )}

                            {(selectedProduct == SubAccountType.Npr || selectedProduct == SubAccountType.JuniorSipp) && this.state.pensionArrangements.length > 0 &&
                                (drawdownPriceLock.UsePriceLock != undefined && <DrawdownPriceLock
                                    isAdmin={this.isAdmin}
                                    subAccountHierarchyId={subAccountHierarchyId}
                                    lockApplied={drawdownPriceLock.UsePriceLock}
                                    platformCharge={drawdownPriceLock.AppliedChargeTypeName}
                                    appliedDate={drawdownPriceLock.AppliedTime}
                                    chargeApplied={drawdownPriceLock.AppliedRate}
                                    onRefresh={() => this.getDrawdownPriceLock()}
                                />)
                            }

                            {clientAccount?.AccountServicePropositionId == ServiceProposition.Wrap &&
                                clientAccount?.Company != "SAVINGSDIRECT" &&
                                !this.isLegacyProduct(selectedProduct) && (
                                    <>
                                        <h2 className="h3 mb-5">
                                            Auto-disinvestment strategy
                                            <AriaTooltip cssWrapper="is-info-icon ml-5" showCloseButton={true}>
                                                {DisinvestmentTipMsg}
                                            </AriaTooltip>
                                            <button
                                                type="button"
                                                title="Edit"
                                                disabled={
                                                    !checkPermission(
                                                        UserClaim.AdviserPortalNewQuoteNewBusinessReadWrite
                                                    )
                                                }
                                                className="edit-circle-icon-button ml-5 label-sr-only"
                                                onClick={() =>
                                                    this.setState({
                                                        showAccountDisinvestmentStrategy: true,
                                                    })
                                                }
                                            >
                                                <span className="icon"></span>
                                                <span className="sr-only">
                                                    Edit account disinvestment strategy
                                                </span>
                                            </button>
                                        </h2>
                                        <div className="panel-subtle">
                                            <table className="table-subtle table-first-last-cell-padding-reset has-first-cell-highlighted mb-0">
                                                <tr>
                                                    <th scope="row">
                                                        Strategy
                                                    </th>
                                                    <td className="cell-right">
                                                        {
                                                            DisinvestmentStrategyTypeMap[
                                                            this.state.accountDisinvestmentStrategy
                                                            ]
                                                        }
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </>
                                )}
                        </div>
                    </div>
                </div>
                {this.state.showAccountDisinvestmentStrategy && this.renderAccountDisinvestmentStrategyView()}
            </>
        );
    }
}
